import { render, staticRenderFns } from "./favorite-toggle.vue?vue&type=template&id=c88b9196&"
import script from "./favorite-toggle.vue?vue&type=script&lang=js&"
export * from "./favorite-toggle.vue?vue&type=script&lang=js&"
import style0 from "./favorite-toggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports